"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;
var _vue = require("vue");
var _account = _interopRequireDefault(require("@/assets/images/account.png"));
var _scroes_rule = _interopRequireDefault(require("@/assets/images/scroes_rule.png"));
var _more = _interopRequireDefault(require("@/assets/images/more.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const _withScopeId = n => ((0, _vue.pushScopeId)("data-v-07f7da47"), n = n(), (0, _vue.popScopeId)(), n);
const _hoisted_1 = {
  class: "i-layout-header-account"
};
const _hoisted_2 = {
  class: "user-account row ai-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: _account.default,
  alt: ""
}, null, -1 /* HOISTED */));
const _hoisted_4 = {
  class: "num"
};
const _hoisted_5 = {
  class: "scores_rules"
};
const _hoisted_6 = {
  class: "scores_rule"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "scores_rule_title"
}, "消耗规则", -1 /* HOISTED */));
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = {
  class: "flex row"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: _account.default,
  alt: ""
}, null, -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "row scores_rule_text"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: _scroes_rule.default,
  alt: ""
}), /*#__PURE__*/(0, _vue.createElementVNode)("div", null, "积分消耗完后，可以发邮件给kent.hu@wpp.com说明项目需求，免费申请更多。")], -1 /* HOISTED */));
const _hoisted_12 = {
  class: "drop_menu"
};
const _hoisted_13 = {
  class: "team row ai-center"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "menu_slot_title menu_slot_title_bg1"
}, "切换登录身份", -1 /* HOISTED */));
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "img-icon"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: _more.default,
  alt: ""
}, null, -1 /* HOISTED */));
const _hoisted_18 = ["onClick"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  style: {
    "margin": "0px 8px",
    "padding-top": "4px",
    "margin-top": "4px"
  },
  class: "bt1"
}, null, -1 /* HOISTED */));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "menu_slot_title menu_slot_title_bg2"
}, "项目管理", -1 /* HOISTED */));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "row ai-center action"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: "https://inspire-wpptech-com.oss-cn-shanghai.aliyuncs.com/ca8ce448-26f5-42f7-98ba-a6ca2769eaed.png",
  alt: ""
}), /*#__PURE__*/(0, _vue.createElementVNode)("span", null, "创建新项目组")], -1 /* HOISTED */));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "row ai-center action"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: "https://inspire-wpptech-com.oss-cn-shanghai.aliyuncs.com/5d1d4797-3f21-454a-a29f-304667c90637.png",
  alt: ""
}), /*#__PURE__*/(0, _vue.createElementVNode)("span", null, "我的项目组")], -1 /* HOISTED */));
const _hoisted_23 = {
  key: 0,
  class: "poptip"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "arrow"
}, null, -1 /* HOISTED */));
const _hoisted_25 = {
  class: "inner"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("span", {
  class: "ivu-mr-8"
}, "点击创建项目组/切换用户身份", -1 /* HOISTED */));

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = (0, _vue.resolveComponent)("Icon");
  const _component_DropdownItem = (0, _vue.resolveComponent)("DropdownItem");
  const _component_DropdownMenu = (0, _vue.resolveComponent)("DropdownMenu");
  const _component_Dropdown = (0, _vue.resolveComponent)("Dropdown");
  const _component_createProjectDialog = (0, _vue.resolveComponent)("createProjectDialog");
  return (0, _vue.openBlock)(), (0, _vue.createElementBlock)(_vue.Fragment, null, [(0, _vue.createElementVNode)("div", _hoisted_1, [(0, _vue.createElementVNode)("div", _hoisted_2, [_hoisted_3, (0, _vue.createElementVNode)("span", _hoisted_4, (0, _vue.toDisplayString)($options.score), 1 /* TEXT */), (0, _vue.createElementVNode)("div", _hoisted_5, [(0, _vue.createElementVNode)("div", _hoisted_6, [_hoisted_7, (0, _vue.createElementVNode)("ul", null, [((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, null, (0, _vue.renderList)($data.scoreArr, (item, index) => {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
      class: "flex",
      key: index
    }, [(0, _vue.createElementVNode)("span", _hoisted_8, (0, _vue.toDisplayString)(item.name), 1 /* TEXT */), (0, _vue.createElementVNode)("div", _hoisted_9, [_hoisted_10, (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(item.score), 1 /* TEXT */)])]);
  }), 128 /* KEYED_FRAGMENT */)), _hoisted_11])])])]), (0, _vue.createElementVNode)("div", _hoisted_12, [(0, _vue.createVNode)(_component_Dropdown, {
    trigger: "click"
  }, {
    list: (0, _vue.withCtx)(() => [(0, _vue.createVNode)(_component_DropdownMenu, null, {
      default: (0, _vue.withCtx)(() => [_hoisted_14, (0, _vue.createCommentVNode)(" <DropdownItem><span style=\"font-weight: bold;\"></span></DropdownItem> "), (0, _vue.createVNode)(_component_DropdownItem, {
        onClick: _cache[0] || (_cache[0] = $event => $options.onChange(''))
      }, {
        default: (0, _vue.withCtx)(() => [(0, _vue.createTextVNode)("个人")]),
        _: 1 /* STABLE */
      }), ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, null, (0, _vue.renderList)($data.profileData.groups, (item, index) => {
        return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_DropdownItem, {
          class: "teams",
          key: index
        }, {
          default: (0, _vue.withCtx)(() => [(0, _vue.createElementVNode)("div", {
            onClick: $event => $options.onChange(item),
            class: (0, _vue.normalizeClass)(["team-item row ai-center jc-between", {
              admin: item.is_admin
            }])
          }, [(0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(item.name), 1 /* TEXT */), (0, _vue.createElementVNode)("div", _hoisted_16, [_hoisted_17, (0, _vue.createElementVNode)("div", {
            onClick: (0, _vue.withModifiers)($event => $options.manege(item), ["stop"]),
            class: "setting row center"
          }, " 项目组管理 ", 8 /* PROPS */, _hoisted_18)])], 10 /* CLASS, PROPS */, _hoisted_15)]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */);
      }), 128 /* KEYED_FRAGMENT */)), _hoisted_19, _hoisted_20, (0, _vue.createVNode)(_component_DropdownItem, {
        onClick: $options.create
      }, {
        default: (0, _vue.withCtx)(() => [_hoisted_21]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]), (0, _vue.createVNode)(_component_DropdownItem, {
        onClick: $options.myTeam
      }, {
        default: (0, _vue.withCtx)(() => [_hoisted_22]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])]),
      _: 1 /* STABLE */
    })]),

    default: (0, _vue.withCtx)(() => [(0, _vue.createElementVNode)("div", _hoisted_13, [(0, _vue.createTextVNode)((0, _vue.toDisplayString)($data.profileItem.name) + " ", 1 /* TEXT */), $data.profileItem.is_admin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
      key: 0,
      class: (0, _vue.normalizeClass)(["identify row center", {
        leader: $data.profileItem.is_admin
      }])
    }, (0, _vue.toDisplayString)($data.profileItem.is_admin ? "组长" : "成员"), 3 /* TEXT, CLASS */)) : (0, _vue.createCommentVNode)("v-if", true), (0, _vue.createCommentVNode)(" <span v-else class=\"leader row center\">组长</span> "), (0, _vue.createVNode)(_component_Icon, {
      type: "ios-arrow-down",
      size: "20",
      color: "#8b919a",
      class: "ivu-ml-8"
    })])]),
    _: 1 /* STABLE */
  }), $data.visible ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_23, [_hoisted_24, (0, _vue.createElementVNode)("div", _hoisted_25, [_hoisted_26, (0, _vue.createVNode)(_component_Icon, {
    type: "md-close",
    size: "18",
    onClick: $options.close,
    style: {
      "cursor": "pointer"
    }
  }, null, 8 /* PROPS */, ["onClick"])])])) : (0, _vue.createCommentVNode)("v-if", true)])]), $data.addProjectDialog ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_createProjectDialog, {
    key: 0,
    show: $data.addProjectDialog,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.addProjectDialog = $event),
    loading: $data.loading,
    onSubmit: $options.submit
  }, null, 8 /* PROPS */, ["show", "loading", "onSubmit"])) : (0, _vue.createCommentVNode)("v-if", true)], 64 /* STABLE_FRAGMENT */);
}